import type { StatusMessage } from '../types';

// packages/lyric-stage/src/stores/useStatusMessageStore.ts
// No-op status toast for Tempera import UI outside Folia.

type StatusSetter = (next: StatusMessage | null | ((prev: StatusMessage | null) => StatusMessage | null)) => void;

export const setStatusMessage: StatusSetter = () => {};

export const useStatusMessageStore = Object.assign(
  () => ({ message: null as StatusMessage | null, setMessage: setStatusMessage }),
  {
    getState: () => ({ message: null as StatusMessage | null, setMessage: setStatusMessage }),
  },
);
